export const MUTATION_COMPARISON_COLORS = ['dataColorPrimary', 'dataColorViolet', 'dataColorGold'];
